import {
  Button,
  ButtonGroup,
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';

import { twilioActions } from 'app/middleware/twilio/actions/twilioActions';
import { usePhoneCallAvailability } from 'components/telephony/hooks/usePhoneCallAvailability';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import styles from './contactCallAction.module.scss';

interface ContactCallActionProps {
  user: User;
}

export function ContactCallAction({
  user,
}: ContactCallActionProps): JSX.Element {
  const dispatch = useAppDispatch();
  const { canMakePhoneCall, phoneCallDisabledTooltipText, selectedFromNumber } =
    usePhoneCallAvailability();

  const handleClick = (phoneNumber: string | null) => {
    if (!phoneNumber) return;

    const { id } = user;

    if (canMakePhoneCall && selectedFromNumber) {
      dispatch(
        twilioActions.twilioMakeCall({
          userId: id,
          toNumber: phoneNumber,
          fromNumber: selectedFromNumber.e164_format,
        }),
      );

      ampli.contactsCardMakeCallClicked();
    }
  };

  return (
    <ButtonGroup variant="secondary">
      <Tooltip
        content={phoneCallDisabledTooltipText}
        disabled={canMakePhoneCall}
        side="left"
      >
        <Button
          icon="phone"
          disabled={!canMakePhoneCall}
          onClick={() => handleClick(user.phone_number)}
          variant="secondary"
          className={styles.noBorderRadiusRight}
        >
          Call
        </Button>
      </Tooltip>
      {user.additional_phone_numbers && (
        <DropdownButton
          icon="angle-down"
          buttonProps={{
            className: styles.dropdownButton,
          }}
          dropdown={
            <DropdownButtonContext.Consumer>
              {({ toggleDropdown }) => (
                <ButtonList>
                  <ButtonList.Item
                    onClick={() => {
                      toggleDropdown();
                      handleClick(user.phone_number);
                    }}
                  >
                    {user.phone_number}
                  </ButtonList.Item>
                  {user.additional_phone_numbers?.map((option) => (
                    <ButtonList.Item
                      key={option}
                      onClick={() => {
                        toggleDropdown();
                        handleClick(option);
                      }}
                    >
                      {option}
                    </ButtonList.Item>
                  ))}
                </ButtonList>
              )}
            </DropdownButtonContext.Consumer>
          }
        />
      )}
    </ButtonGroup>
  );
}
